//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import VipLevel from "../../../components/VipLevel";

export default {
  components: {
    VipLevel,
  },
  computed: {
    ...mapState({
      level: (state) => (state.userInfo.vipInfo.vipLevel || 0) + 1,
    }),
  },
  methods: {
    handleVipInfo() {
      this.$router.push(
        "/discounts/discountsDetail?id=104&articleName=赢在VIP%20星月级待遇&applyType&bonusType&configId"
      );
    },
    handleBonus() {
      if (this.level === 1) {
        this.$toast("升级vip2可解锁该活动哦");
        return;
      }
      this.$router.push("/dailyDraw");
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/VipInfo/index.vue